<template>
    <div class="flex xs12"> 
        <template v-for="(list, index) in data">
            <div :class="['input-wrapper', getIfFieldFocusClass(list.items)]" 
                :key="`description-cat${index}`">
                <locations
                    v-if="list.category == 'loca'"
                    :data="list.items"
                    :questions="questions"
                    :hideLocationImage="hideLocationImage"
                    :examination_typeID="examination_typeID"
                    :focus="hiddenParams && ['orien', 'loca', 'dist' , 'switchLocation'].indexOf(hiddenParams.focus) >= 0"
                    :focusIndex="hiddenParams ? hiddenParams.nowLocationsIndex : null"
                    @addLocation="$emit('addLocation')"
                    @deleteLocation="$emit('deleteLocation', $event)"
                    @locationChange="$emit('locationChange', $event)"
                ></locations>
                <div class="header" v-else>{{ list.category }}</div>
                <template v-for="(item, key) in list.items">
                    
                    <template v-if="item.config">
                         <laid-out-select-input
                            v-if="item.config.inputType == 's'"
                            :key="`description-item${index}-${key}`"
                            :options="item.config.options"
                            :value="item.value"
                            :multiple="true"
                            @change="$emit('change', { newValue: $event, qID: item.questionID })"
                        ></laid-out-select-input>
                        <textfield-landscape
                            v-if="item.config.inputType == 't'"
                            :key="`description-item${index}-${key}`"
                            :data="item"
                            @change="$emit('change', { newValue: $event, qID: item.questionID })"
                        ></textfield-landscape>
                        <v-textarea
                            v-if="item.config.inputType == 'ta'"
                            :key="`description-item${index}-${key}`"
                            :label="item.config.question"
                            :value="item.value"
                            @change="$emit('change', { newValue: $event, qID: item.questionID })"
                            no-resize
                            outline
                            hide-details
                            height="88px"
                            row-height="20px"
                        ></v-textarea>
                        <horizontal-check-boxes
                            v-if="item.config.inputType == 'c'"
                            :key="`description-item${index}-${key}`"
                            :options="item.config.options"
                            :value="item.value"
                            @change="$emit('change', { newValue: $event, qID: item.questionID })"
                        ></horizontal-check-boxes>
                        <number-select-input 
                            v-if="item.config.field == 'prgC' || item.config.field == 'prgM' || item.config.field == 'dist'"
                            :key="`description-item${index}-${key}`"
                            :data="item"
                            :float="false"
                            :unit="'cm'"
                            @change="$emit('change', { newValue: $event, qID: item.questionID })"
                        ></number-select-input>
                    </template>     
                </template>
                <div class="clear"></div>             
            </div>
        </template>
    </div>
</template>
<script>
import LaidOutSelectInput from '@/components/LaidOutSelectInput.vue'
import TextfieldLandscape from '@/components/TextfieldLandscape.vue'
import HorizontalCheckBoxes from '@/components/HorizontalCheckBoxes.vue'
import NumberSelectInput from '@/components/NumberSelectInput.vue'
import Locations from '@/components/Locations.vue'

import forms from '@/utils/forms'

export default {
    name: 'DescriptionRecordsForm',

    props: {
        data: {
            required: true,
            type: Array
        },
        questions: Object,
        hiddenParams: {
            required: false,
            type: Object
        },
        hideLocationImage: {
            required: false,
            default: false,
            type: Boolean
        },
        examination_typeID:Number
    },
    components: {
        NumberSelectInput,
        LaidOutSelectInput,
        TextfieldLandscape,
        HorizontalCheckBoxes,
        Locations
    },
    methods: {
        getIfFieldFocusClass(items) {
            if (this.hiddenParams) {
                let isSelect = false
                items.map(item => {
                    if (item.config) {
                        if (item.config.field == this.hiddenParams.focus) {
                            isSelect = true
                        }
                    }
                })

                if (isSelect) {
                    setTimeout(() => {
                        this.scrollToFocus()
                    }, 0)
                }

                return isSelect ? 'focus': ''
            } else {
                return ''
            }
        },

        test(d){
          alert(d.id)
          alert(d.column)
          alert(d.value)
        },
        scrollToFocus () {
            const focusdEls = document.querySelectorAll('.input-wrapper.focus')
            const focusd = [...focusdEls].filter(el => el.offsetParent !== null)[0]
            const container = document.querySelectorAll('.v-window')[0]
            if (typeof(focusd) != 'undefined') {
                container.scrollTop = focusd.offsetTop
            }
        }
    }
}
</script>
<style lang="scss">
@import "../../styles/variables";
@import url('https://fonts.googleapis.com/css2?family=Noto+Sans:ital@0;1&display=swap');
.input-wrapper{
    font-family: 'Noto Sans', sans-serif;
    font-size: 20px;
    margin-bottom: 8px;
    .layout {
        margin: 0;
    }
    &.focus {
        color: $defaultPink;
        background: $formHighlight;
        .theme--light.v-label, p {
            color: $defaultPink !important;
        }
    }
}
.header {
    text-align: left;
    width: 100%;
    text-transform: capitalize;
}
</style>